import "@/common/debug";
import { IIndexState } from "@/store/index";
import { resetOldMonitor, registerMonitorV2 } from "@/common/selfMonitor";
import { message } from "@/components/common/Message";
import Banner from "@/components/index/Banner";
import HotRank from "@/components/index/HotRank";
import HotTab from "@/components/index/HotTab";
import Recommend from "@/components/index/Recommend";
import ScreenAd from "@/components/common/ScreenAd";
import { store, asyncGetIndexData } from "@/store/index";
import { asyncGetPmpData } from "@/store/com";
import { asyncInitAllAppStatus } from "@/store/common/action/appStatus";
import React, { useCallback, useEffect } from "react";
import { render } from "react-dom";
import { Helmet } from "react-helmet";
import { connect, Provider } from "react-redux";
import "@/styles/index.scss";
import { IAdData, ISoftTab } from "@/common/interface";
import "@/utils/noticeInstalledFlash";

/* import Searches from "@/components/index/Searches"; */
resetOldMonitor();
registerMonitorV2("QH_780_1732", true);

const Index: React.FC<{
  onGetIndexData: () => Promise<void>;
  ad: IAdData;
  soft: ISoftTab[];
  comData: any;
  onGetPmtData: () => Promise<any>;
  onAsyncInitAllAppStatus: (data: any) => Promise<any>;
}> = ({
  onGetIndexData,
  ad,
  comData,
  onGetPmtData,
  soft,
  onAsyncInitAllAppStatus,
}) => {
  useEffect(() => {
    onGetIndexData().catch((e) => {
      message.show({
        type: "error",
        content: e.message || "网络错误，请稍后重试",
      });
    });
  }, [onGetIndexData]);

  const getSoftId = useCallback(() => {
    const searchStArr = soft.filter((item, index) => {
      return index > 0;
    });
    const ids: number[] = [];
    searchStArr.forEach((item) => {
      if (item.data) {
        item.data.forEach((soft) => {
          ids.push(soft.soft_id);
        });
      }
    });

    return ids;
  }, [soft]);

  useEffect(() => {
    const softIds = getSoftId();
    if (softIds.length) {
      onAsyncInitAllAppStatus(getSoftId());
    }
  }, [getSoftId, onAsyncInitAllAppStatus, soft]);

  useEffect(() => {
    const nowDate = new Date().getTime();
    const respectTime = 1670371200000;
    if (respectTime > nowDate) {
      document.getElementsByTagName("html")[0].className = "gray";
      const timeId = setTimeout(() => {
        document.getElementsByTagName("html")[0].classList.remove("gray");
      }, respectTime - nowDate);
      return () => {
        clearTimeout(timeId);
      };
    }
  }, []);
  return (
    <div className="wrap">
      <Helmet title="今日热门 - 360软件管家" />
      <Banner />
      <Recommend />
      <div className="hot-area">
        <HotTab />
        <div className="right-bar">
          <HotRank />
          {/* <Searches /> */}
        </div>
      </div>
      <ScreenAd position="mainad" data={ad} />
    </div>
  );
};

const mapStateToProps = ({
  indexData: { ad, soft },
  comData,
}: IIndexState) => ({
  ad: ad[0],
  soft,
  comData,
});

const mapDispatchToProps = {
  onGetIndexData: asyncGetIndexData,
  onGetPmtData: asyncGetPmpData,
  onAsyncInitAllAppStatus: asyncInitAllAppStatus,
};

const ConnectIndex = connect(mapStateToProps, mapDispatchToProps)(Index);

render(
  <Provider store={store}>
    <ConnectIndex />
  </Provider>,
  document.getElementById("app"),
);
